/*!
 *
 *	fade-contents.js
 *
 */

$.fn.fadeContents = function(options){
	var opt = options ? options : {};
	$(this).each(function(){
		new fadeUnit(this, opt);
	});
};

var fadeUnit = function(_this, opt){
	this.$elem = $(_this);
	this.setting = $.extend({}, this.default, opt);
	this.init();
};

fadeUnit.prototype = {
	init: function(){
		this.setTop();
		this.isStart = false;
		this.setEvent();
	},
	setTop: function(){
		this.top = this.$elem.offset().top + (this.$elem.outerHeight() / 2);
		if( origin.VPisMobile ){
			this.top = this.$elem.offset().top + 100;
		};
	},
	setEvent: function(){
		var self = this;
		origin.$window.on('scroll', function(){
			if( !self.isStart ){
				var wt = $(this).scrollTop() + origin.wh;
				if( wt > self.top ){
					self.$elem.addClass(self.setting.fadeClass);
				};
			};
		});

		origin.$window.on('changeMobile changePC fadeInit', function(){
			self.setTop();
		});
	},
	default: {
		fadeClass: 'fading'
	}
};


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/fade-contents.js
// module id = 15
// module chunks = 0